"use client";
import Loader from "@/component/Loader";

export default function Loading() {
  return (
    <Loader />
  );
}